import { ExperimentRegistration } from "./types"

/**
 * Experiment registry for tracking the active A/B test experiment.
 *
 * This registry maintains a record of which experiment is currently active
 * and which variant the experiment is assigned to. Only one experiment can be
 * active at a time - registering a new experiment will replace any existing one.
 */

class ExperimentRegistry {
  private experiment: ExperimentRegistration | null = null

  /**
   * Registers an experiment. Any previously registered experiment will be replaced.
   * Only one experiment can be active at a time.
   */
  registerExperiment(registration: ExperimentRegistration): void {
    this.experiment = registration
  }

  getActiveExperiment(): ExperimentRegistration | null {
    return this.experiment
  }

  /**
   * Clear the registered experiment, useful for testing.
   */
  clearExperiment(): void {
    this.experiment = null
  }
}

export const experimentRegistry = new ExperimentRegistry()
